import httpService from '@Utils/httpService';

const baseUrl = 'api/permissions';

export default {
  getDefaultPermissions(id) {
    return httpService.get({
      url: `${baseUrl}/default/${id}`,
    });
  },
  
  getPermissions(companyId) {
    if(!companyId){
      return httpService.get({
        url: `${baseUrl}`,
      });
    }
    return httpService.get({
      url: `${baseUrl}/${companyId}`,
    });
  },
  
  updatePermission(companyId, data) {
    return httpService.put({
      url: `${baseUrl}/${companyId}`,
      data,
    });
  }
};
